import template from "./organization-name.html";

const OrganizationNameComponent = {
  template: template,
  controller: class OrganizationNameController {
    /* @ngInject */
    constructor($rootScope, $scope) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;

      this.$scope.$on("refreshOrganization", () => {
        this.organization = this.$rootScope.organization;
      });
    }
  },
};

export default OrganizationNameComponent;
